import React from "react";
import { Stack, Typography, Button } from "../../mui";
import { useTheme } from "@mui/material/styles";

const privacyUrl = "https://sampled.com/legal/client-portals/privacy-policy/";
const termsUrl = "https://sampled.com/legal/client-portals/terms-of-use/";

const handleRedirect = (url) => {
  window.open(url, "_blank", "noreferrer noopener");
};

const Footer = () => {
  const theme = useTheme();
  return (
    <Stack marginTop="auto" height="2rem">
      <Stack
        width="100%"
        sx={{ bgcolor: "#637697" }}
        p="0.3rem"
        position="absolute"
        bottom="-6px"
        left="-5px"
        zIndex="1210"
        borderRadius="0 0 0.4rem 0.4rem"
      >
        <Stack gap={2} direction="row" justifyContent="center">
          <Button
            sx={{
              color: theme.palette.buttonDefault.main, fontSize: "1rem", padding: "0px", textTransform: "none",
              lineHeight: "1.5rem"
            }}
            onClick={() => handleRedirect(privacyUrl)}
          >
            Privacy Policy
          </Button>
          <Typography color="white" fontSize="1rem">
            |
          </Typography>
          <Button
            sx={{
              color: theme.palette.buttonDefault.main, fontSize: "1rem", padding: "0px", textTransform: "none",
              lineHeight: "1.5rem"
            }}
            onClick={() => handleRedirect(termsUrl)}
          >
            Terms of Use
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Footer;
